/**
 * Page menu bar
 */

import $ from 'jquery';

$(function() {
  const pageMenuDropdown = document.querySelector('#page-menu-dropdown');
  if (!pageMenuDropdown) {
    return;
  }

  // Close the dropdown when a menu link is clicked 
  $(pageMenuDropdown).on('click', 'a', function() {
    // $('#page-menu-dropdown').foundation('close');
    $(pageMenuDropdown).addClass('is-closing');
    setTimeout(function() {
      var plugin = $(pageMenuDropdown).data('zfPlugin');
      if (plugin) plugin.close();
      $(pageMenuDropdown).removeClass('is-closing');
    }, 400);
  });
});
